import Axios from 'axios'
import { IValidateBarCodeParams } from 'models/Budget'
import { IBaseParamsApi } from 'models/CommonInterface'
import {
	IGetSalesMonitorItemsParams,
	ISelectSalesMonitorParams
} from 'models/SalesMonitor'
// const urlBase = 'vta_cab_selcompr'
const urlBase = 'vta_MonitorPreparacion'

export const getZonesApi = async () => {
	const params = { incluye_todas: 1 }
	const response = await Axios.get('tablas/Zonas', { params })
	return response.data
}

export const getSalesMonitorItemsApi = async (
	params: IGetSalesMonitorItemsParams
) => {
	const response = await Axios.get(urlBase, { params })
	return response.data
}

export const confirmSalesMonitorApi = async (params: IBaseParamsApi) => {
	const response = await Axios.post(`${urlBase}/confirmar`, params)
	return response.data
}

export const selectSalesMonitorApi = async (
	params: ISelectSalesMonitorParams
) => {
	const response = await Axios.post(`${urlBase}/seleccionar`, params)
	return response.data
}

export const validateBarCodeMonitorApi = async (
	params: IValidateBarCodeParams
) => {
	const response = await Axios.post(`${urlBase}/codbar`, params)
	return response.data
}
